//
// AGNES - Technical Support Web
//
// MainController.js
//
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//

"use strict"

const EVENT_USERAUTHENTICATED = "oidc_user_authenticated";
const EVENT_USERCHANGED = "oidc_user_changed";

angular.module("Agnes")
    .controller("MainController", [
        "$rootScope", "$scope", "$http", "$sessionStorage", "$activity", "$notification", "$uibModal", "$oidc", "$user",
        function (rootScope, scope, http, sessionStorage, activity, $notification, modal, oidc, user) {

            // Pokud je obsažen parametr signagain, bylo zvoleno na authorizačním
            // serveru zvoleno sign -in -again, kde se uživatel přihlásí buď znovu nebo pod jiným profilem
            // oidc.signOut() tato metoda vyvolá okno popsané výše
            if (location.href.includes('signagain=true')) {
                oidc.signOut();
            }

            // Page title
            scope.pageTitle = "AGNES";
            scope.version = __AGNES__.app.version;

            // Notifications
            scope.$notification = $notification;

            // Storage
            scope.$storage = sessionStorage.$default({
                repairer: {
                    id: -1
                },
                repairers: []
            });

            // Repairers
            scope.loadRepairers = function () {
                activity.start();
                return http
                    .get("/api/repairer", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    }).then(function (response) {
                        activity.finish();
                        scope.$storage.repairers = response.data;
                    }, function (response) {
                        activity.finish();
                        $notification.addError(response.status, response);
                    });
            };

            scope.$watch("repairer", function () {
                if (typeof scope.repairer != "undefined") {
                    if (scope.repairer.id !== scope.$storage.repairer.id) {
                        scope.$storage.repairer = scope.repairer;
                    }
                }
            });

            // Print
            scope.print = function () {
                window.print();
            };

            scope.repairerProfile = function () {
                modal.open({
                    template: require("../Templates/RepairerProfile.html"),
                    controller: "RepairerProfileController"
                });
            };

            // About
            scope.loadAbout = function () {
                activity.start();
                http
                    .get("/api/about")
                    .then(function (response) {
                        activity.finish();
                        scope.about = response.data;
                        if (scope.about.mode === "Test") {
                            scope.pageTitle = "AGNES UAT";
                        } else if (scope.about.mode === "Development") {
                            scope.pageTitle = "AGNES DEV";
                        }
                    }, function (response) {
                        activity.finish();
                        $notification.addError(response.status, response);
                    });
            };

            scope.loadRepairer = function () {
                var repId = scope.$storage.repairer.id == -1
                    ? user.repairerId
                    : scope.$storage.repairer.id;

                http
                    .get("/api/repairer/" + repId, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        scope.$storage.repairer = response.data;
                    }, function (response) {
                    });

                if (scope.user.isOnBehalfOfDealers && (typeof scope.$storage.repairers === "undefined" || scope.$storage.repairers.length === 0)) {
                    scope.loadRepairers();
                }
            };

            scope.loadParty = function () {
                http
                    .get("/api/party/" + user.loginName, {
                        params: {
                            userName: user.name
                        },
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        scope.$storage.party = response.data;
                    }, function (response) {
                    });
            }

            // Car info
            scope.carInfoKeyPress = function ($event) {
                if ($event.keyCode === 13) {
                    $scope.carInfoSearch();
                }
            };

            scope.carInfoSearch = function () {
                var newWindow = window.open(
                    "/car-info/" + encodeURIComponent(scope.carInfoVin)
                );
                newWindow.focus();

                scope.carInfoVin = null;
            };

            scope.logout = function () {
                scope.$storage.repairer = {
                    id: -1
                };

                window.location.href = scope.getlogoutUrl("Agnes");
            };

            scope.getlogoutUrl = function (appName) {

                let baseUrl = __AGNES__.auth.authority;
                let returnUrlParam = encodeURIComponent(location.origin + "?signagain=true");
                return baseUrl + "Sign-out?appName=" + appName + "&returnUrl=" + returnUrlParam;
            }

            // On load
            scope.loadAbout();

            scope.user = user;

            rootScope.$on(EVENT_USERAUTHENTICATED, function () {
                //
                console.log(EVENT_USERAUTHENTICATED);
                //
                scope.loadParty();
                scope.loadRepairer();
            });

            rootScope.$on(EVENT_USERCHANGED, function () {
                //
                console.log(EVENT_USERCHANGED);
                //
                scope.loadParty();
                scope.loadRepairer();
            });
        }
    ]);